import { render, staticRenderFns } from "./SystemUserRegister.vue?vue&type=template&id=4654cc7e&scoped=true"
import script from "./SystemUserRegister.vue?vue&type=script&lang=js"
export * from "./SystemUserRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654cc7e",
  null
  
)

export default component.exports